export default __webpack_public_path__ + "static/media/navlogoScroll.23f6e8b0.svg";